import { createIcon } from '@chakra-ui/icons';

export const PeopleIcon = createIcon({
  displayName: 'PeopleIcon',
  viewBox: '0 0 50 50',
  path: (
    <path
      transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
      d="M203 430 c-18 -11 -33 -24 -33 -28 0 -5 -11 -7 -24 -5 -38 8 -76 -36
-76 -87 0 -22 7 -52 16 -65 21 -32 13 -51 -30 -69 -32 -13 -56 -41 -56 -65 0
-6 16 -11 35 -11 24 0 35 -5 35 -15 0 -13 27 -15 180 -15 153 0 180 2 180 15
0 10 11 15 35 15 55 0 41 47 -25 80 -43 22 -48 35 -25 66 8 10 15 38 15 62 0
34 -6 48 -26 67 -15 14 -35 25 -45 25 -20 0 -79 31 -79 43 0 14 -45 7 -77 -13z
m75 -16 c47 -23 53 -83 18 -156 -26 -55 -16 -80 44 -108 29 -13 56 -32 61 -42
9 -17 0 -18 -151 -18 -151 0 -160 1 -151 18 5 10 32 29 61 42 62 29 71 54 42
113 -29 61 -28 112 2 142 29 29 33 30 74 9z m-123 -45 c4 -6 7 -26 7 -46 0
-20 9 -51 19 -70 24 -43 17 -68 -22 -82 -16 -6 -43 -20 -59 -31 -18 -13 -41
-20 -57 -18 l-28 4 34 19 c73 43 78 50 62 87 -8 18 -16 52 -18 74 -4 35 -1 44
18 58 27 19 35 20 44 5z m234 -5 c19 -14 22 -23 18 -58 -2 -22 -10 -56 -18
-74 -16 -37 -11 -44 62 -87 l34 -19 -28 -4 c-16 -2 -39 5 -57 18 -16 11 -43
25 -59 31 -40 14 -46 39 -21 88 11 22 20 58 20 81 0 44 11 50 49 24z"
    />
  ),
});
